import { useNavigate } from 'react-router-dom'
import { faPlus } from '@fortawesome/pro-regular-svg-icons'
import bankWarning from '@/assets/bank-warning.svg'
import heardBanking from '@/assets/heard-banking.svg'
import { TextColors, TypographyStyles } from '@/styles'
import { Button, Card, CardColors, Image, Text } from '@/ui'
import { useHeardBankingPromo } from '@/features/banking/banking-promo.helpers'
import { BANKING_DASHBOARD_ROUTES } from '@/features/banking/banking-dashboard-routes'
import {
  HEARD_BANKING_PROMO_COPY,
  HEARD_BANKING_STANDARD_DISCLAIMER,
} from '@/features/banking/banking.constants'
import { InlineLinkText } from '@/features/user/dashboard/feature-announcement/renderInlineLinks'
import { setPlaidTarget } from '@/reducers/finances/plaidLauncherReducer'
import { useAppDispatch } from '@/utils/typeHelpers'

export const NoBankAccountsBanner = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { isActive, deadline, disclaimer } = useHeardBankingPromo()

  return (
    <div className="flex flex-col gap-6">
      <Card className="my-0">
        <div className="flex flex-col items-center">
          <img src={bankWarning} alt="" />
          <Text variant={TypographyStyles.H1} className="mt-4">
            Account connection needed to start bookkeeping
          </Text>
          <Text
            variant={TypographyStyles.BODY_SM}
            className="mt-2 text-center px-44"
          >
            Connect all bank and credit card accounts used for your practice,
            including existing business accounts and personal accounts with
            business expenses.
          </Text>
          <Button
            className="mt-6"
            iconLeft={faPlus}
            onClick={() => dispatch(setPlaidTarget({ mode: 'connect' }))}
          >
            Connect an account
          </Button>
        </div>
      </Card>
      {isActive && (
        <Card className="my-0" color={CardColors.EMPHASIS}>
          <div className="flex items-center justify-between gap-6">
            <div className="flex flex-col">
              <Text
                variant={TypographyStyles.BODY_XS}
                color={TextColors.MUTED}
                className="uppercase"
              >
                Free member benefit
              </Text>
              <Text variant={TypographyStyles.DISPLAY_SM}>
                {HEARD_BANKING_PROMO_COPY.titlePrefix}
                <sup>*</sup>
                {HEARD_BANKING_PROMO_COPY.titleSuffix}
              </Text>
              <Text variant={TypographyStyles.BODY_SM} color={TextColors.MUTED}>
                FDIC insurance eligible<sup>*</sup>
              </Text>
              <Text variant={TypographyStyles.BODY_SM} className="mt-4">
                {deadline
                  ? HEARD_BANKING_PROMO_COPY.body(deadline.date, deadline.time)
                  : HEARD_BANKING_PROMO_COPY.bodyNoDeadline}
              </Text>
              <Button
                className="mt-4 w-fit"
                onClick={() => navigate(BANKING_DASHBOARD_ROUTES.intro)}
              >
                {HEARD_BANKING_PROMO_COPY.cta}
              </Button>
              <Text
                variant={TypographyStyles.BODY_XS}
                color={TextColors.DISABLED}
                className="mt-4"
              >
                {disclaimer ? (
                  <InlineLinkText text={disclaimer} />
                ) : (
                  HEARD_BANKING_STANDARD_DISCLAIMER
                )}
              </Text>
            </div>
            <Image
              src={heardBanking}
              alt=""
              className="flex-shrink-0 self-start"
            />
          </div>
        </Card>
      )}
    </div>
  )
}
